import {
  UPDATE_INPUT,
  UPDATE_RECEIPT_ID,
  UPDATE_ADD_INPUT,
  UPDATE_INPUT_COMMON,
  UPDATE_ADD_CONDITION,
  UPDATE_ADD_INFO,
  UPDATE_ADD_JD,
  UPDATE_ADD_CONF,
  UPDATE_ADD_SKILL_INPUT,
  UPDATE_ADD_ENVI_INPUT,
  RESET_INPUT,
  RESET_INPUT_COMMON,
  RESET_ADD_INPUT,
  CHANGE_MODIFY_MODE,
  CHANGE_VALID,
  REGISTER,
  ADD_REGISTER,
} from './actions';

const AppReducer = (state, action) => {
  switch(action.type){
    case UPDATE_INPUT_COMMON: {
      const { updInputCommon } = action;
      const { workCategory,
        workCategoryOtherDetail,
        clickID,
        mediaID } = updInputCommon;
      return { ...state, 
        workCategory,
        workCategoryOtherDetail,
        clickID,
        mediaID };
    }
    case UPDATE_INPUT: { 
      const { updInput } = action;
      const { 
        workDetailText, 
        companyNameText, 
        dept, 
        chargePersonNameText, 
        tel, 
        email, 
        address, 
        ekiCd, 
        ekiName,
        employmentPlacementDispatching,
      } = updInput;
      return { ...state,
        workDetailText, 
        companyNameText, 
        dept, 
        chargePersonNameText, 
        tel, 
        email, 
        address, 
        ekiCd, 
        ekiName,
        employmentPlacementDispatching };
    }
    case UPDATE_ADD_INPUT: {
      const { updAddInput } = action;
      const { howToDo,
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workPeriodDate,
      } = updAddInput;
      return { ...state,
        howToDo,
        bgdOfRecruitment,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        bgdOfRecruitmentCmnt,
        workPeriodDate,
      };
    }
    case UPDATE_ADD_CONDITION: {
      const { updAddCondition } = action;
      const { 
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd,
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,
        hourSalaryApiErr,
      } = updAddCondition;
      return { ...state,
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd,
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,
        hourSalaryApiErr,
      };
    }
    case UPDATE_ADD_JD: {
      const { updAddJd } = action;
      const {
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList
      } = updAddJd;
      return {
        ...state,
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList
      };
    }
    case UPDATE_ADD_INFO: { 
      const { updAddInfo } = action;
      const { 
        companyNameText, 
        dept, 
        chargePersonNameText, 
        tel, 
        email, 
        address,
        employmentPlacementDispatching
      } = updAddInfo;
      return { ...state, 
        companyNameText, 
        dept, 
        chargePersonNameText, 
        tel, 
        email, 
        address,
        employmentPlacementDispatching
      };
    }
    case UPDATE_ADD_CONF: {
      const { updAddConf } = action;
      const {
        // AddInput
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workPeriodDate,

        // AddJobDescription
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList,

        // AddSkill
        excelSkill,
        otherSkills,
        skillOtherCmnt,

        // AddCondition
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd,
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,

        // AddEnvi
        welfare,
        welfareCmnt,
        workEnvi,
        ageRange,
        genderRange,
        workEnviCmnt,

        // AddInfo
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        employmentPlacementDispatching,

        otherComment,
      } = updAddConf;
      return { ...state,
        // AddInput
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workPeriodDate,

        // AddJobDescription
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList,

        // AddSkill
        excelSkill,
        otherSkills,
        skillOtherCmnt,

        // AddCondition
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd,
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,

        // AddEnvi
        welfare,
        welfareCmnt,
        workEnvi,
        ageRange,
        genderRange,
        workEnviCmnt,

        // AddInfo
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        employmentPlacementDispatching,

        otherComment,
      };
    }
    case UPDATE_ADD_SKILL_INPUT: { // スキル
      const { updAddSkillInput } = action;
      const { excelSkill, otherSkills, skillOtherCmnt } = updAddSkillInput;

      return {
        ...state,
        excelSkill,
        otherSkills,
        skillOtherCmnt,
      };
    }
    case UPDATE_ADD_ENVI_INPUT: { // 職場環境
      const { updAddEnviInput } = action;
      const { welfare, welfareCmnt, workEnvi, ageRange, genderRange, workEnviCmnt } = updAddEnviInput;
      return {
        ...state,
        welfare,
        welfareCmnt,
        workEnvi,
        ageRange,
        genderRange,
        workEnviCmnt,
      };
    }
    case RESET_INPUT: {
      return { ...state,
        workDetailText: '', 
        companyNameText: '',
        dept: '',
        chargePersonNameText: '',
        tel: '',
        email: '',
        address: '',
        ekiCd: '',
        ekiName: '',
        employmentPlacementDispatching: false,
      };
    }
    case RESET_INPUT_COMMON: {
      return { ...state,
        workCategory: '', 
        workCategoryOtherDetail: '', 
        clickID: '', 
        mediaID: '',
      };
    }
    case RESET_ADD_INPUT: {
      return { ...state,
        howToDo: '01',
        bgdOfRecruitment: '',
        desiredStartDateKubun: '',
        desiredStartDate: '',
        workPeriod: '',
        bgdOfRecruitmentCmnt: '',
        workPeriodDate: '',
      };
    }
    case UPDATE_RECEIPT_ID: {
      const { updReceiptID } = action;
      const { receiptID } = updReceiptID;
      return { ...state, receiptID };
    }
    case CHANGE_MODIFY_MODE: {
      const { isModify } = action;
      return { ...state, isModify };
    }
    case CHANGE_VALID: {
      const { path, valid } = action;
      const { validMap } = state;
      return { ...state, validMap: { ...validMap, [path]: valid } };
    }
    case REGISTER: {
      return { ...state, isRegistered: true };
    }
    case ADD_REGISTER: {
      return { ...state, isAddRegistered: true };
    }
    default: {
      return state;
    }
  }
};

export default AppReducer;
